<template>
  <div id="pay" class="full_layout pay" v-loading.fullscreen="loading">
    <h3 class="informationTitle">支付</h3>
    <div class="payBox">
      <div class="payDetail" v-if="orderInfo!=null">
        <p>{{orderInfo.Title}}</p>
        <div class="OrderPrice" v-if="orderInfo.OrderPresale!=2">订单总价：￥{{orderInfo.OrderPrice.toLocaleString()}}</div>
        <div class="OrderPrice" v-if="orderInfo.OrderPresale==2">订单总价：{{orderInfo.RealPoints}}积分 +￥{{orderInfo.OrderPrice.toLocaleString()}}</div>
      </div>
    </div>
    <div class="payBox payOtherDetail" v-if="otherType">
      <div class="goBack" @click="otherType=false"></div>
      <div class="payOtherBox">
        <p>您可以通过以下渠道转账进行支付，转账后，请上传转账凭证，便于我们核对订单</p>
          <div class="otherinfo_title">选择渠道</div>
        <ul class="otherinfoList addressList">
          <li v-for="(item,index) in otherInfo" :key='index' :class="[item.account==otherPay.transferAccount?'on':'']" @click="checkOtherPay(item)">
            <div>
              <div><span>{{item.language!='ch'?'Company Name:':'户号:'}}</span><span>{{item.account}}</span></div>
              <div><span>{{item.language!='ch'?'Bank Name:':'户名:'}}</span><span>{{item.company}}</span></div>
              <div><span>{{item.language!='ch'?'Bank Account:':'开户行:'}}</span><span>{{item.method}}</span></div>
              <div v-if="item.code!=''&&item.code"><span>Swift Code:</span><span>{{item.code}}</span></div>
            </div>
          </li>
        </ul>
        <div class="payOtherFrom">
          <!-- <el-select class="info_ipt" v-model="otherPay.transferMethod" @input="otherPayInfo(otherPay)" placeholder="请选择支付方式">
            <el-option v-for="(item,index) in otherInfo" :key="index" :label="item.label" :value="item.label"></el-option>
          </el-select> -->
          <el-input class="info_ipt" v-model="otherPay.transferJournal" @input="otherPayInfo(otherPay)" placeholder="请输入转账流水号"></el-input>
          <div class="info_ipt">请上传转账记录凭证</div>
          <el-upload v-if="!otherPay.imgUrl" class="uploadImgBox" ref="upload" action="" :http-request="uploadImg" list-type="picture" :show-file-list="false" :limit="limit" :on-exceed="handleExceed" :before-upload="beforeUpload" :on-success="uploadImgSuccess" :on-error="uploadImgError" :on-remove="handleRemove" :with-credentials="true">
            <span class="uploadImg">
            </span>
          </el-upload>
          <div class="uploadImgBox" v-if="otherPay.imgUrl">
            <span class="uploadImg">
              <i class="delete" @click="deleteImg()"></i>
              <el-image :src="otherPay.imgUrl+'?imageView2/2/w/120'" fit="contain" :preview-src-list="[otherPay.imgUrl]">
              </el-image>
            </span>
          </div>
          <el-button class="info_btn" :disabled='disabled' type="primary" @click="payOtherFrom(otherPay)">提交</el-button>
        </div>
      </div>
    </div>
    <div class="payBox" v-if="!otherType">
        <div class="pay-tab">
          <div :class="['pay-type',PayChannel==1?'on':'']" @click="changePay(1)">支付宝、微信</div>
          <!-- <div :class="['pay-type',PayChannel==1?'on':'']" @click="changePay(1)">支付宝</div> -->
          <!-- <div :class="['pay-type',PayChannel==8?'on':'']" @click="changePay(8)">微信</div> -->
        </div>
      <div class="payWebSocket">
        <div class="payImg" :class="imgClass">
          <!-- <img :src="text"> -->
          <canvas id="QRCode_header" style="width: 200px; height: 200px"></canvas>
        </div>
        <div class="payType">扫码支付</div>
        <div class="paybtn">
          <span @click="goToPage('/checkout/'+orderid)">支付失败？</span>
          <span @click="goToPage('/order/detail/'+orderid)">支付成功</span>
          <!-- <el-button type="primary" @click="goToPage('/order/detail/'+orderid)">支付成功</el-button>
        <el-button @click="goToPage('/checkout/'+orderid)">支付失败</el-button> -->
        </div>
      </div>
      <div class="payOther" v-if="orderInfo&&orderInfo.PayType!=3">如果您没有办法进行付款，可以选择<span @click="otherType=true">其他转账方式</span></div>
    </div>
  </div>
</template>
<script>
import { getInfo,numAdd, numSub, numMulti } from "@/api/public";
import * as signalR from '@aspnet/signalr'
import QRCode from "qrcode";
export default {
  name: 'pay',
  components: {},
  data() {
    return {
      otherType: false,
      limit: 1,
      otherInfo: this.$enumInfo.otherPayOrder,
      cosConfig: this.$enumInfo.cosConfig,
      userInfo: getInfo(),
      text: null,
      websock: null,
      orderid: this.$route.params.id || '',
      loading: false,
      orderInfo: null,
      imgClass: '',
      disabled: true,
      // id 订单id  
      // transferMethod 转账方式    
      // transferAccount 转账账户  
      // transferJournal 转账流水号 
      // imgUrl 凭证图片
      otherPay: { 'imgUrl': '', 'id': null, 'transferMethod': this.$enumInfo.otherPayOrder[0]['method'], 'transferAccount': this.$enumInfo.otherPayOrder[0]['account'], 'TransferCompany': this.$enumInfo.otherPayOrder[0]['company'], 'transferJournal': '', 'SwiftCode': this.$enumInfo.otherPayOrder[0]['code']},
      signal: '',
      list: '',
      PayChannel:1,//支付渠道 1支付宝、 7微信公众号、8微信小程序
      AuthPay:{}//支付信息
    }
  },
  watch: {
    'otherPay': {
      handler(val) {
        this.otherPayInfo(val)
      }
    },
  },
  mounted() {},
  created() {
    this.getOrderPay();
    this.getOrderDetail();
    //this.NowCos()
  },
  destroyed() {},
  methods: {

    //计算价格
    priceCount(num1,num2,type){
      let num=0;
      if(type=='add'){
          num = numAdd(num1, num2)
      }
      if(type=='sub'){
          num = numSub(num1, num2)
      }
      if(type=='multi'){
          num = numMulti(num1, num2)
      }
      return num.toLocaleString()
    },
    deleteImg() {
      let that = this
      that.otherPay.imgUrl = ''
      that.otherPayInfo(that.otherPay)
    },
    checkOtherPay(obj) {
      this.otherPay.transferMethod = obj.method
      this.otherPay.transferAccount = obj.account
      this.otherPay.TransferCompany = obj.company
      this.otherPay.SwiftCode = obj.code
      this.otherPayInfo(this.otherPay)
    },
    otherPayInfo(val) {
      let that = this
      if (val.transferMethod != '') {
        that.otherInfo.map(res => {
          if (res.label == val.transferMethod) {
            val.transferAccount = res.value
          }
        })
      }
      if (val.imgUrl != '' && val.transferMethod != '' && val.transferAccount != '' && val.transferJournal != '') {
        that.disabled = false
      } else {
        that.disabled = true
      }
    },
    //msg 1 支付成功
    receiveData(user, msg) {
      let that = this
      console.log(user, 'user', msg, 'msg')
      var msg = msg;
      var url = "";
      var type = "success";
      if (msg != '1') {

        console.log('支付失败')
        //支付失败
        url = '/checkout/' + this.orderid
        msg = '支付失败'
        type = "error";
        this.imgClass = "opacity error"
        that.signal.stop()
      } else {
        console.log('支付成功')
        url = '/order/detail/' + this.orderid
        msg = '支付成功'
        type = "success";
        this.imgClass = "opacity success"
        that.signal.stop()
        //支付成功
      }
      this.$message({
        message: msg,
        type: type
      });
      setTimeout(function() { that.goToPage(url) }, 1000)
    },
    goToPage(val) {
      this.$router.push({ path: val })
    },
    getpayStatus() {
      let that = this
      let url = process.env.VUE_APP_WS + '/chatHub?GroupId=' + that.orderid;
      console.log(url, 'url')
      that.signal = new signalR.HubConnectionBuilder().withUrl(url, {}).configureLogging(signalR.LogLevel.Information) //打印日志
        .build()
      that.signal.on('ReceiveMessage', that.receiveData);
      that.signal.start().then(() => {
        console.log('连接');
      }).catch((data) => {
        console.log('连接失败');
        that.signal.stop()
        //that.getpayStatus()
      })
    },
    changePay(val){
      if(val==1){
        this.PayChannel=val;
        this.getOrderPay();
      }
    },
    getOrderPay() {
      let that = this
      that.loading = true;
      // that.text = that.$interface.Unionpay + '?orderId=' + that.orderid;
      let data = { orderId: that.orderid ,PayChannel:that.PayChannel}
      that.$get(that.$interface.Unionpay, data).then(res => {
        // console.log("$interface.Unionpay",res);
        if (res.Result != 0) {       
          that.AuthPay = res.Data;   
          that.getQRCode();//生成二维码
        } else {
          that.$message.error(res.Msg);
        }
        that.loading = false
      })

      that.loading = false;
      that.getpayStatus()
    },
    getQRCode() {
      var that = this;
      var _AuthPay = that.AuthPay
      // console.log("_AuthPay",_AuthPay);
      if (_AuthPay.expend&&_AuthPay.expend.pay_info) {
        //生成的二维码为URL地址js
        this.qrUrl = _AuthPay.expend.pay_info;
        let opts = {
          errorCorrectionLevel: "H", //容错级别
          type: "image/png", //生成的二维码类型
          quality: 0.3, //二维码质量
          margin: 0, //二维码留白边距
          width: 200, //宽
          height: 200, //高
          text: "daka pay", //二维码内容
          color: {
            dark: "#333333", //前景色
            light: "#fff", //背景色
          },
        };

        let msg = document.getElementById("QRCode_header");
        // 将获取到的数据（val）画到msg（canvas）上
        QRCode.toCanvas(msg, this.qrUrl, opts, function (error) {
          if (error) {
            console.log("二维码加载失败", error);
            this.$message.error("二维码加载失败");
          } else { }
          that.qrLoading = false;
        });
      }
    },
    getOrderDetail() {
      let that = this
      that.loading = true;
      that.otherPay.id = that.orderid;
      let data = { Id: that.orderid }
      that.$get(that.$interface.GetOrderById, data).then(res => {
        if (res.Result != 0) {
          var item=res.Data;
          let orderTitle = item.OrderDetails.length > 1 ? item.OrderDetails[0].Title + '等更多' : item.OrderDetails[0].Title
          var orderInfo={ Title: orderTitle, OrderPrice: item.RealOrderPrice,OrderPresale:item.OrderPresale,RealPoints:item.RealPoints,PayType:item.PayType};
          if(item.OrderPresale==1){
            // var item.OrderDetails[0].num
            if(!item.IsPayDeposit){
              orderInfo.OrderPrice=item.AdvancePrice.toLocaleString()
            }else{
              orderInfo.OrderPrice=that.priceCount(item.RealOrderPrice,item.AdvancePrice,'sub').toLocaleString()
            }
          }
          that.orderInfo = orderInfo;
        } else {
          that.$message.error(res.Msg);
        }
        that.loading = false
      })
    },
    payOtherFrom(obj) {
      let that = this
      let data = obj
      that.$post(that.$interface.SubmitPayVoucher, data).then(res => {
        if (res.Result != 0) {
          let url = '/order/detail/' + this.orderid
          let msg = '提交成功'
          let type = "success";
          this.$message({
            message: msg,
            type: type
          });
          setTimeout(this.goToPage(url), 1000)
        } else {
          this.$message.error("提交凭证失败，请重新提交");
        }
      })
    },
    uploadImg(param) {
      var that = this;
      var fd = new FormData();
      fd.append('fileName', param.file);
      that.$post(that.$interface.UploadImage, fd).then(res => {
        if (res.Result != 0) {
          that.otherPay.imgUrl = res.Data
          that.otherPayInfo(that.otherPay)
        } else {
          this.$message.error("上传凭证失败，请重新上传");
        }
      })
    },
    beforeUpload(file) {},
    handleExceed() {},
    uploadImgSuccess() {},
    uploadImgError() {},
    handleRemove() {}


  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/pay.css";

</style>



// WEBPACK FOOTER //
// src/pages/pay/pay.vue